<template>
  <resource-collection>
    <template slot-scope="{item}">
      <customer :customer="item"/>
    </template>
  </resource-collection>
</template>

<script>
import Customer from './Customer.vue';
import collection from '../../mixins/collection';
import ResourceCollection from '../resources/ResourceCollection.vue';

export default {
  mixins: [collection],

  components: { Customer, ResourceCollection },

  mounted() {
    this.$authorization.register('orders-create');
    Event.listen('customerUpdated', customer => this.update(customer));
    Event.listen('customerCreated', customer => this.prepend(customer));
    Event.listen('customerDeleted', customer => this.remove(customer));
  },
};
</script>